<template>
<div class="cost-container">
  <div class="cost-wrp">
    <el-table
        :data="tableData"
        border
        :show-header="false"
        style="width: 100%">
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="scope.row.sort !== 8" class="normal">{{scope.row.tit}}</div>
          <div v-else class="bold-row clear-float">{{scope.row.tit}}<i @click="toggle"></i></div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="scope.row.sort !== 8" class="normal rgt">
            {{scope.row.num1}}<span v-if="scope.row.num1 !== '-' && scope.row.num1 !== null">%</span>
          </div>
          <div v-else class="bold-row rgt">
            {{scope.row.num1}}<span v-if="scope.row.num1 !== '-' && scope.row.num1 !== null">%</span>
            </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div v-if="scope.row.sort !== 8" class="normal rgt">
            <span v-if="scope.row.num2 !== '-' && scope.row.num2!== null">$</span>{{scope.row.num2}}
          </div>
          <div v-else class="bold-row rgt">
            <span v-if="scope.row.num2 !== '-' && scope.row.tit !== 'Labour(Hrs)' && scope.row.num2!== null">$</span>{{scope.row.num2}}<span v-if="scope.row.num2 !== '-' && scope.row.tit === 'Labour(Hrs)' && scope.row.num2!== null">Hrs</span>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
        <div v-else>-</div>
      </template>
    </el-table>
  </div>
</div>
</template>

<script>
import api from '../../../api/account'
export default {
  data () {
    return {
      loading: true,
      tableData: [
        {
          tit: 'Forecast Revenue',
          sort: 0,
          num1: null,
          num2: null
        },
        {
          tit: 'Average Hourly Rate',
          sort: 1,
          num1: null,
          num2: null
        },
        {
          tit: 'Profit Target',
          sort: 2,
          num1: null,
          num2: null
        },
        {
          tit: 'Fixed OH',
          sort: 3,
          num1: null,
          num2: null
        },
        {
          tit: 'Variable OH',
          sort: 4,
          num1: null,
          num2: null
        },
        
        {
          tit: 'Weekly Rent',
          sort: 5,
          num1: null,
          num2: null
        },

        {
          tit: 'Target Variable Cost',
          sort: 6,
          num1: null,
          num2: null
        },
        {
          tit: 'COGs',
          sort: 7,
          num1: null,
          num2: null
        },
        {
          tit: 'Labour($)',
          sort: 8,
          num1: null,
          num2: null
        }
      ],
      cur: 'default',
      hour: null,
      default: null,
    }
  },
  created() {
    if (!this.$route.params.id) {
      return
    }
    api.costDis({
      params: {
        venueId: parseInt(this.$route.params.id)
      },
      callback: this.callback
    })
  },
  methods: {
    callback (res) {
      var that = this
      if(res.data.code == 0){
        that.tableData[0].num2 = res.data.data.forecastRevenue !== null ? this.$box.formatDecimal2(res.data.data.forecastRevenue, 2) : '-'
        that.tableData[1].num2 = res.data.data.averageHourlyRate !== null ? this.$box.formatDecimal2(res.data.data.averageHourlyRate, 2) : '-'
        that.tableData[2].num1 = res.data.data.profitTargetPercentage !== null ? res.data.data.profitTargetPercentage : '-'
        that.tableData[2].num2 = res.data.data.profitTarget !== null ? this.$box.formatDecimal2(res.data.data.profitTarget, 2) : '-'
        that.tableData[3].num1 = res.data.data.fixedOhPercentage !== null ? res.data.data.fixedOhPercentage : '-'
        that.tableData[3].num2 = res.data.data.fixedOh !== null ? this.$box.formatDecimal2(res.data.data.fixedOh, 2) : '-'
        that.tableData[4].num1 = res.data.data.variableOhPercentage !== null ? res.data.data.variableOhPercentage : '-'
        that.tableData[4].num2 = res.data.data.variableOh !== null ? this.$box.formatDecimal2(res.data.data.variableOh, 2) : '-'

        that.tableData[5].num1 = res.data.data.weeklyRentPercentage !== null ? res.data.data.weeklyRentPercentage : '-'
        that.tableData[5].num2 = res.data.data.weeklyRent !== null ? this.$box.formatDecimal2(res.data.data.weeklyRent, 2) : '-'

        that.tableData[6].num1 = res.data.data.targetVariableCostPercentage
        that.tableData[6].num2 = res.data.data.targetVariableCost !== null ? this.$box.formatDecimal2(res.data.data.targetVariableCost, 2) : '-'
        that.tableData[7].num1 = res.data.data.cogsPercentage !== null ? res.data.data.cogsPercentage : '-'
        // res.data.data.cogs = 166
        that.tableData[7].num2 = res.data.data.cogs !== null ? this.$box.formatDecimal2(res.data.data.cogs, 2) : '-'
        that.tableData[8].num1 = res.data.data.labourCostPercentage !== null ? res.data.data.labourCostPercentage : '-'
        that.tableData[8].num2 = res.data.data.labourCost !== null ? this.$box.formatDecimal2(res.data.data.labourCost, 2) : '-'
        that.default = res.data.data.labourCost !== null ? this.$box.formatDecimal2(res.data.data.labourCost, 2) : '-'
        that.hour = res.data.data.labourHours !== null ? this.$box.formatDecimal2(res.data.data.labourHours, 2) : '-'
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    toggle () {
      var that = this
      if (this.cur === 'default') {
        this.cur = 'hour'
        that.tableData[8].num2 = null
        setTimeout(() => {
          that.tableData[8].num2 = that.hour
          that.tableData[8].tit = 'Labour(Hrs)'
        }, 300)
      } else {
        this.cur = 'default'
        that.tableData[8].num2 = null
        setTimeout(() => {
          that.tableData[8].num2 = that.default
          that.tableData[8].tit = 'Labour($)'
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cost-container{
  width: 100%;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
}
.cost-wrp{
  width: 100%;
  background: #151C27;
  h2{
    line-height: 70px;
    width: 100%;
    box-sizing: border-box;
    padding-left: 30px;
    font-size:20px;
    font-weight:600;
    color: #fff;
  }
  .normal{
    font-size: 18px;
  }
  .bold-row{
    font-weight: 600;
    font-size: 20px;
    i{
      width: 28px;
      height: 28px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      background-image: url('../../../assets/t.png');
      cursor: pointer;
      float: right;
    }
  }
  .rgt{
    text-align:right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/cost/index.vue